<div class="form-field">
  <input matInput
         type="text"
         i18n-placeholder
         placeholder="Filter by layer name..."
         tmAutoFocus
         [formControl]="filterControl" />
</div>
